import { createFileRoute } from '@tanstack/react-router';
import { EarningsPage } from '@/features/payouts/pages/earnings-page';

export const Route = createFileRoute('/_app/me/earnings')({ component: EarningsPage });
